__webpack_require__.p = "/Simple-Calculator/";